import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { selectNewPrimaryResidenceBudget } from 'src/store/selectors/home/equity'
import Detail from './Detail'

export default {
  GemContainer: connect(state => ({
    qaTag: 'rentBuyGem',
    amount: selectNewPrimaryResidenceBudget(state)
  })),
  Detail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.rentBuyQuestion',
      defaultMessage: 'Do I need to update my home?'
    },
    topic: {
      id: 'Homeowner.purchasePower.rentBuyTopic',
      defaultMessage: 'buying a second primary home'
    }
  })
}
